import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M15.409 9.167c0 3.333-5.209 6.875-5.209 6.875S4.992 12.5 4.992 9.167c0-2.917 2.447-5.209 5.208-5.209 2.762 0 5.209 2.292 5.209 5.209Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M10.2 11.042a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);